import { render, staticRenderFns } from "./ListBrand.vue?vue&type=template&id=f8710e3c"
import script from "./ListBrand.vue?vue&type=script&lang=js"
export * from "./ListBrand.vue?vue&type=script&lang=js"
import style1 from "./ListBrand.vue?vue&type=style&index=1&id=f8710e3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports